import { useEffect, useState } from 'react';

export interface UsuarioEmpresa {
  _id: string;
  nome?: string;
  email: string;
  cargo?: string;
}

let cachePromise: Promise<UsuarioEmpresa[]> | null = null;
let cacheData: UsuarioEmpresa[] | null = null;

const fetchUsuarios = async (session: any): Promise<UsuarioEmpresa[]> => {
  if (cacheData) return cacheData;
  if (cachePromise) return cachePromise;
  const userEmail = session?.usuario?.email || session?.user?.email || '';
  cachePromise = fetch(`/api/users?userEmail=${encodeURIComponent(userEmail)}`)
    .then(r => r.json())
    .then(d => {
      const list: UsuarioEmpresa[] = Array.isArray(d?.data) ? d.data : [];
      cacheData = list;
      return list;
    })
    .catch(() => []);
  return cachePromise;
};

export const useUsuariosEmpresa = (session: any) => {
  const [usuarios, setUsuarios] = useState<UsuarioEmpresa[]>(cacheData || []);
  useEffect(() => {
    fetchUsuarios(session).then(setUsuarios);
    // eslint-disable-next-line
  }, []);
  return usuarios;
};

export const invalidarCacheUsuarios = () => { cachePromise = null; cacheData = null; };
